// ============================================
// FILE 3: /frontend/src/api/compare.api.js
// PURPOSE: Compare API endpoints
// ============================================

import apiClient from './client.js';

export const compareAPI = {
  // Compare listings
  compareListings: async (listingIds) => {
    const response = await apiClient.post('/compare', { listingIds });
    return response.data;
  },

  // Save comparison
  saveComparison: async (listingIds, name = '') => {
    const response = await apiClient.post('/compare/save', { listingIds, name });
    return response.data;
  },

  // Get user's saved comparisons
  getUserComparisons: async (userId) => {
    const response = await apiClient.get(`/compare/user/${userId}`);
    return response.data;
  },

  // Delete comparison
  deleteComparison: async (comparisonId) => {
    const response = await apiClient.delete(`/compare/${comparisonId}`);
    return response.data;
  },
};
